import React, { useState } from "react";
import styled from "styled-components";

const CheckInWrapper = styled.div`
  margin: 32px 0 0 0;
  padding: 24px;
  background: #f7f7f7;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
`;

const MOOD_LABELS = [
  { label: "Very Bad", emoji: "😞" },
  { label: "Bad", emoji: "🙁" },
  { label: "Okay", emoji: "😐" },
  { label: "Good", emoji: "🙂" },
  { label: "Excellent", emoji: "😃" }
];

export default function DailyCheckIn({ onSubmit }) {
  const [mood, setMood] = useState(3);
  const [didPractice, setDidPractice] = useState(false);
  const [note, setNote] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = () => {
    if (onSubmit) {
      onSubmit({ mood, didPractice, note });
      setSubmitted(true);
      setTimeout(() => setSubmitted(false), 2000);
      setMood(3);
      setDidPractice(false);
      setNote("");
    }
  };

  return (
    <CheckInWrapper>
      <h3>Daily Check-In</h3>
      <div>
        <label>Mood today: </label>
        <input
          type="range"
          min={1}
          max={5}
          value={mood}
          onChange={e => setMood(Number(e.target.value))}
          style={{ width: 120, margin: "0 8px", verticalAlign: "middle" }}
        />
        <span style={{ fontWeight: 600, fontSize: 24, marginLeft: 8 }}>
          {MOOD_LABELS[mood - 1].emoji}
        </span>
        <span style={{ marginLeft: 10, fontSize: 14, color: "#555" }}>
          {MOOD_LABELS[mood - 1].label}
        </span>
        <div style={{ display: "flex", justifyContent: "space-between", fontSize: 12, marginTop: 4 }}>
          {MOOD_LABELS.map((m, i) => (
            <span key={i} style={{ textAlign: "center", width: 30 }}>
              {i + 1}<br />{m.emoji}<br />{m.label}
            </span>
          ))}
        </div>
      </div>
      <div style={{ margin: "12px 0" }}>
        <label>
          <input
            type="checkbox"
            checked={didPractice}
            onChange={e => setDidPractice(e.target.checked)}
          />
          {" "}I practiced my solution today
        </label>
      </div>
      <div>
        <textarea
          value={note}
          onChange={e => setNote(e.target.value)}
          placeholder="Any notes for today?"
          rows={2}
          style={{ width: "100%", borderRadius: 8, padding: 8 }}
        />
      </div>
      <button
        style={{
          marginTop: 14,
          padding: "10px 28px",
          borderRadius: 20,
          background: "#FFD166",
          color: "#222",
          fontWeight: 600,
          border: "none",
          cursor: "pointer"
        }}
        onClick={handleSubmit}
        type="button"
      >
        Submit Check-In
      </button>
      {submitted && (
        <div style={{ color: "#27ae60", marginTop: 10, fontWeight: 600 }}>
          Check-in submitted!
        </div>
      )}
    </CheckInWrapper>
  );
}
